import { useEffect, useState } from "react";
import axios from "axios";
import { Quotes } from "@phosphor-icons/react";
import { SectionHead, Reveal } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Reviews() {
    const [items, setItems] = useState(null);

    useEffect(() => {
        axios.get(`${API}/testimonials`).then((r) => setItems(r.data)).catch(() => setItems([]));
    }, []);

    const placeholders = [1, 2, 3];

    return (
        <section className="relative border-t border-white/10 bg-void py-28 md:py-36" data-testid="reviews-section">
            <div className="mx-auto max-w-[1400px] px-5 md:px-10">
                <SectionHead
                    number="08"
                    label="Client results"
                    title="Proof, when it's earned."
                    copy="We don't fabricate reviews. Verified HIGHTS client testimonials — with names, businesses and results — will appear here as soon as clients approve them."
                />
                <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-3">
                    {items && items.length > 0
                        ? items.map((t) => (
                            <Reveal key={t.id}>
                                <figure className="flex h-full flex-col border border-white/12 bg-surface p-8" data-testid={`testimonial-${t.id}`}>
                                    <Quotes size={24} className="text-white/40" />
                                    <blockquote className="mt-5 flex-1 text-sm font-light leading-relaxed text-white/70">"{t.quote}"</blockquote>
                                    <figcaption className="mt-6 border-t border-white/10 pt-5">
                                        <p className="text-sm font-bold text-white">{t.name}</p>
                                        <p className="text-xs text-white/45">{t.business}</p>
                                        {t.result && <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-white/60">{t.result}</p>}
                                    </figcaption>
                                </figure>
                            </Reveal>
                        ))
                        : placeholders.map((p) => (
                            <Reveal key={p} delay={p * 0.08}>
                                <div className="flex h-full min-h-[240px] flex-col items-center justify-center border border-dashed border-white/15 p-8 text-center" data-testid={`testimonial-placeholder-${p}`}>
                                    <Quotes size={24} className="text-white/25" />
                                    <p className="mt-5 max-w-xs text-sm font-light text-white/40">
                                        Verified client story — published here once approved by the client.
                                    </p>
                                    <p className="mt-4 font-mono text-[9px] uppercase tracking-[0.3em] text-white/25">Awaiting verification</p>
                                </div>
                            </Reveal>
                        ))}
                </div>
            </div>
        </section>
    );
}
